import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { userIdentityShape, catalogBibShape, branchShape, libraryShape } from '@bibliocommons/bc-prop-types';
import { SecondarySolidButton } from '@bibliocommons/base-buttons';

import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import accountShape from 'app/shapes/accountShape';
import LiteSuggestionForm from './LiteSuggestionForm';

const MODAL_KEY = 'suggest-for-purchase-lite-modal';

export default function LiteSuggestionButton({
  currentLibrary,
  branches,
  preferredBranches,
  currentAccount,
  modalActions,
  suggestForPurchaseActions,
  suggestForPurchaseTransactions,
  currentUser,
  catalogBib
}) {
  function handleOpen() {
    modalActions.openModal(MODAL_KEY, { accountRequired: true });
  }

  function handleClose() {
    modalActions.closeModal(MODAL_KEY);
  }

  return (
    <div className="cp-lite-suggestion-button">
      <SecondarySolidButton dataKey="lite-suggestion-button" handleClick={handleOpen} block>
        <FormattedMessage id="suggest_for_purchase" />
      </SecondarySolidButton>
      <ModalContainer modalKey={MODAL_KEY} handleClose={handleClose}>
        <LiteSuggestionForm
          handleClose={handleClose}
          currentLibrary={currentLibrary}
          branches={branches}
          preferredBranches={preferredBranches}
          currentAccount={currentAccount}
          suggestForPurchaseActions={suggestForPurchaseActions}
          suggestForPurchaseTransactions={suggestForPurchaseTransactions}
          currentUser={currentUser}
          catalogBib={catalogBib}
        />
      </ModalContainer>
    </div>
  );
}

LiteSuggestionButton.propTypes = {
  currentLibrary: libraryShape.isRequired,
  branches: ImmutablePropTypes.listOf(branchShape).isRequired,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  currentAccount: accountShape,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  suggestForPurchaseActions: PropTypes.objectOf(PropTypes.func).isRequired,
  suggestForPurchaseTransactions: ImmutablePropTypes.map.isRequired,
  currentUser: userIdentityShape,
  catalogBib: catalogBibShape.isRequired
};
